import { useState, useContext } from "react";
import CreateProductUI from "./CreateProductUI";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { IProduct } from "src/types/global";
import { productService } from "@services/ProductService";
import { GlobalAlertContext } from "@providers/GlobalAlertProvider";
import { getNumberCurrency } from "@utils/utils";
const CreateProduct = () => {
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    formState: {
      errors
    }
  } = useForm<IProduct>({});
  const [isLoading, setIsLoading] = useState(false);
  const [showError, setShowError] = useState(false);
  const {
    setGlobalAlertMessage,
    setGlobalAlertSeverity,
    showGlobalAlert
  } = useContext(GlobalAlertContext);
  const onSubmit = async (product: IProduct) => {
    try {
      setGlobalAlertSeverity("success");
      setGlobalAlertMessage("!Listo! El producto ha sido creado correctamente");
      setIsLoading(true);
      product.id = 0;
      product.status = 0;
      product.price = String(getNumberCurrency(product.price));
      const res = await productService.create(product);
      navigate(`/productos/${res.data.id}`, {
        state: {
          showAlert: true,
          product: {
            ...res.data
          }
        }
      });
      showGlobalAlert();
    } catch {
      setShowError(true);
    } finally {
      setIsLoading(false);
    }
  };
  return <CreateProductUI register={register} onSubmit={handleSubmit(onSubmit)} isLoading={isLoading} showError={showError} errors={errors} closeError={() => setShowError(false)} handleCancelClick={() => navigate("/productos")} />;
};
export default CreateProduct;